import React, { Component } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

import avatar1 from "../../assets/images/users/sara_hall.png"
import profileImg from "../../assets/images/route.png"

class WelcomeComp extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <React.Fragment>
        <Card className="overflow-hidden">
          <div className="bg-primary bg-soft">
            <Row>
              <Col xs="7">
                <div className="text-primary p-3">
                  <h5 className="text-primary">Quote of the day</h5>
                  <br/>
                  <p> &quot;Over every mountain there is a path, although it may not be seen from the valley. &quot; </p>
                  <p><em>- Theodore Roethke</em></p>
                </div>
              </Col>
              <Col xs="5" className="align-self-end">
                <img src={profileImg} alt="" className="img-fluid" />
              </Col>
            </Row>
          </div>
          <CardBody className="pt-0">
            <Row>
              <Col sm="4">
                <div className="avatar-md profile-user-wid mb-4">
                  <img
                    src={avatar1}
                    alt=""
                    className="img-thumbnail rounded-circle"
                  />
                </div>
                <h5 className="font-size-15 text-truncate">Jenna</h5>
                <p className="text-muted mb-0 text-truncate">Sales Expert</p>
              </Col>

              <Col sm="8">
                <div className="pt-4">
                  <Row>
                    <Col xs="6">
                      <h5 className="font-size-15">17</h5>
                      <p className="text-muted mb-0">Opps won this week</p>
                    </Col>
                    <Col xs="6">
                      <h5 className="font-size-15">3rd</h5>
                      <p className="text-muted mb-0">Leader Board</p>
                    </Col>
                  </Row>
                  <div className="mt-4">
                    <Link
                      to="./calendar"
                      className="btn btn-primary btn-sm"
                    >
                      See Agenda   {" "}<i className="mdi mdi-arrow-right ms-1"/>
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}

export default WelcomeComp